import React from 'react'
import { setup } from 'goober'

setup(React.createElement)

export { styled, css, glob, extractCss } from 'goober'
